import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { ReadyTransacitons } from "../../../../components/DirectDeposit/Transactions/Ready";

export interface IReadyTransacitonsPage { }

export const ReadyTransacitonsPage: FC<IReadyTransacitonsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Transacitons Ready"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<ReadyTransacitons />}
		/>
	);
};
